import { createSendTag } from '@/lib/send-tag';

/** How long a send replayed from before the chat was ready had waited, in ms. */
export const earlyReplayWait = createSendTag<number>();
